import React,{useState,useEffect} from 'react'
import {Box, DataTable,Button } from 'grommet'
import { withRouter } from 'react-router-dom';
import { Add } from 'grommet-icons';
import { NavigationSnackBar } from '../../components/utils/shared/shared';
import { APIRequest } from '../../components/utils/shared/requests';
import {ShipmentSuccessNotification} from '../../components/utils/shared/shipmentViewFunctions'

function LabCustomers (props) {
  const [customers, setCustomers] = useState([]);
  const [customerSucc, setCustomerSucc] = useState(props.location.customerSucc)
  useEffect(() => {   
    APIRequest('/lab_customers').then(result => setCustomers(result))
    setTimeout(() => {
      setCustomerSucc(undefined);
    }, 5000)
   },[]);
  return (
   <Box wrap flex="grow">
        <NavigationSnackBar title={'Customers'} user={props.user} pages={[{name: 'Dashboard', link: '/dashboard'}]}  />
        {customerSucc && (<ShipmentSuccessNotification label={"Customer"} edit={props.location.edit} />)}
      <Box direction='row' justify='end'>
        <Button margin="large" icon={<Add />} label="Create Customer" onClick={() => props.history.push('/customers/new')}/>
      </Box>
      <Box width='xlarge' alignSelf='center' elevation='medium' round pad='small' margin='medium'>
     <DataTable  pad={'small'} margin='xsmall' background={{ header: { color: '#18445C'}, footer: { color: 'dark-3', opacity: 'strong' }, }} columns={[ {header:"ID",property:"id",primary:true,sortable:true,search:false}, {header:"Name",property:"name"}, {header:"Country",property:"address.Country.CountryName",sortable:true,search:false}, ]} onClickRow={({datum}) => {props.history.push({pathname:`/customers/edit/${datum.id}`})}} data={customers} />
       </Box>
   </Box>
  )
}


export default withRouter(LabCustomers)
